import Icon from '@/components/snippets/icon/icon'

/**
 *
 * @param {{props: {handleNextPage: (key: 'next' | 'previous') => void, index: number, pageMin: number, pageMax: number}}} param0
 * @returns
 */
export const PaginateHeader = ({ props }) => {
  if (props.pageMax <= 0) return <></>
  return (
    <div className={'flex w-full justify-end'}>
      <div className={'flex flex-row gap-2'}>
        <button
          className={'transition-opacity disabled:opacity-40'}
          disabled={props.index === props.pageMin}
          onClick={() => {
            props.handleNextPage('previous')
          }}
        >
          <Icon id="arrow-left" />
        </button>
        <div className={'my-auto py-4'}>
          {props.index + 1} of {props.pageMax + 1}
        </div>
        <button
          disabled={props.index >= props.pageMax}
          className={'transition-opacity disabled:opacity-40'}
          onClick={() => {
            props.handleNextPage('next')
          }}
        >
          <Icon id="arrow-right" />
        </button>
      </div>
    </div>
  )
}
